<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3>法规标准库</h3>
				</div>
				<div class="info-content" v-html="infoText">
				</div>
			</div>
		</div>
	</el-main>
</template>

<script>
export default {
	data() {
		return {
            infoText: `
              <p>“法规标准库”是特规通的核心基础模块，面向特种设备行业高频、刚需的规范查询与核验场景，提供<strong>可持续更新、可多维检索、可视化呈现、可在线阅读、可引用留痕</strong>的一体化法规标准服务。模块内包含两个互补的资源库：<strong>特种设备行业库</strong>与<strong>全国标准库</strong>，既满足行业专用规范的深度使用，也支持跨行业、跨领域的标准检索需求。</p><h3>1）特种设备行业库：行业文件一站式获取与核验</h3><p>特种设备行业库系统收录法律、法规、规章、TSG、行政文件、国家标准、行业标准及技术图书等<strong>11类文件</strong>，累计<strong>3000+份</strong>，覆盖八大类特种设备及设计、制造、安装、检验检测、使用管理、维护保养等全流程场景，帮助用户在同一平台内完成从“找文件”到“看条文”再到“做引用”的完整闭环。</p><p></p><p>为保证内容的时效性与可用性，行业库持续更新，与市场监管总局、国标委、标准出版社等权威机构数据库定期同步，确保能够<strong>及时收录最新发布/修订的法规标准</strong>，并维护文件的<strong>实施状态与有效性</strong>（例如现行、废止、被替代等），降低工程应用中“用错版本、引用失效”的风险。</p><h3>2）多维分类与检索：快速定位“你要找的那一份”</h3><p>面对特种设备规范体系“文件多、分类复杂、版本变更频繁”的现实，平台提供多种分类与检索模式，支持用户按<strong>编号、名称、文件类型、效力层级、发布机构、发布时间、实施时间、技术委员会等多维条件</strong>组合检索；同时支持对文件<strong>全文内容检索</strong>，让用户无需反复翻目录或凭记忆找关键词，即可快速、准确定位目标文件与关键条文，显著提升查找效率。</p><h3>3）元数据可视化：一眼看懂文件“身份信息”</h3><p>每份文件均收录完整元数据并以可视化方式呈现，帮助用户快速判断文件是否适用、是否现行、是否需要关注修订版本。平台提供文件<strong>简介、目录预览</strong>等辅助信息，并依托“标准法规数据中心”技术，系统化建立文件之间的关联网络，包括：</p><ul><li>引用关系：哪些文件引用了它、它又引用了哪些文件；</li><li>编制历史：修订/换版脉络与关键节点；</li><li>替代关系：被哪些文件替代、替代了哪些文件。 </br>这类关系能力可帮助用户更高效地完成规范体系梳理与合规核验，尤其适用于方案论证、审查校核与培训学习等场景。</li></ul><h3>4）在线阅读：原文阅读 + 智能阅读，兼顾严谨与效率</h3><p>特种设备领域文件支持在线阅读，提供两种互补的阅读模式：</p><ol><li>PDF阅读模式：忠实呈现原文件版式，适用于核对原文、审查留痕、对照图表等场景。平台提供结构化目录，支持快速跳转对应页码，让“翻页找条款”变成“点目录直达”。</li><li>智能文档阅读模式：以结构化数据为基础，对文件内容进行可视化呈现与精细化定位。支持全文检索快速定位所需内容，可对条文内容直接复制粘贴，并提供智能引用能力（引用时自动带出文件编号、名称及条款号，形成规范性引用格式），便于写报告、出具技术文件与内部沟通。与此同时，平台提供丰富的笔记与学习辅助功能，帮助用户在学习标准与日常工作中沉淀知识、形成可复用的个人经验库。</li></ol><h3>5）全国标准库：覆盖更广的官方标准信息检索</h3><p>除行业库外，特规通还提供“全国标准库”，收录全国范围内<strong>国家标准、行业标准、地方标准、团体标准、计量规范规程等</strong>共计<strong>30万+条</strong>标准文件数据，支持用户在工作中进行跨领域标准检索与对照。所有文件信息来自官方平台，并支持<strong>一键跳转至标准文件的官方原文</strong>，实现快速核验与权威查询。数据库保持实时更新，确保信息准确与全面。</p><h3>6）官方来源与数据质量：正版合规、准确可用</h3><p>两个库的共同特点是：<strong>数据来源规范、文件信息可靠、可追溯可核验</strong>。平台坚持使用官方数据渠道，确保文件为正版合规；同时，结构化数据经人工审核校对，提升条款、图表等要素的准确性与可用性。通过“行业库+全国库”的组合能力，特规通为特种设备工程技术人员提供稳定、可信、便捷的法规标准数据服务，让“查规范、用规范、学规范”更加高效，支撑专业工作与合规管理的高质量开展。</p>
            `
        };
	}
};
</script>

<style lang="less" scoped>
.info-wrap {
	margin-left: 20px;
	padding: 20px 0 !important;
	font-size: 14px;
	color: #686f83;
	line-height: 1.8;
	background-color: #ffffff;
	box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
	border-radius: 15px;
	 min-height: calc(100vh - 120px);
	h3 {
		margin: 0 0 10px;
		font-weight: 400;
		font-size: 24px;
		color: #333333;
	}
}
.info-item {
	margin-bottom: 20px;
}
.info-head {
	margin-bottom: 25px;
	padding-bottom: 15px;
	border-bottom: 1px solid #cccccc;
	.topbox {
		color: #888888;
		dd {
			margin: 0 30px 0 0;
		}
	}
}
</style>

<style lang="less">
.info-content {
	// text-indent: 2em;
	padding: 0 30px;
}

.info-content p {
	margin: 0;
}

.info-content h5 {
	color: #1f2329;
	font-size: 16px;
	margin: 0;
	padding: 0;
	line-height: 34px;
	margin-top: 10px;
}

.info-content h6 {
	color: #1f2329;
	font-size: 16px;
	margin: 0;
	padding: 0;
	line-height: 34px;
	position: relative;
}
.info-content h6:before {
	content: ' ';
	display: inline-block;
	width: 5px;
	height: 5px;
	background: #1474e2;
	border-radius: 50%;
	margin-right: 10px;
	position: absolute;
	top: 16px;
	left: 18px;
}

.info-box {
	padding-bottom: 30px;
}
</style>
